import React from 'react';
import PropTypes from 'prop-types';

import FaqItem from './faq-item';
import css from './faq.less';

const Faqs = props => {
  const { items, currentStatus, orderType, senderID, orderID } = props;
  return (
    <ul className={css.container}>
      {items.map(item => (
        <FaqItem
          key={item.title}
          {...item}
          orderType={orderType}
          senderID={senderID}
          orderID={orderID}
          currentStatus={currentStatus}
        />
      ))}
    </ul>
  );
};

Faqs.defaultProps = {
  currentStatus: null,
  orderID: null,
  senderID: null,
  orderType: null,
};

Faqs.propTypes = {
  currentStatus: PropTypes.string,
  orderID: PropTypes.string,
  senderID: PropTypes.number,
  orderType: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default Faqs;
